import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './Review.scss';

import ReviewFund from './ReviewFund';
import BankSnapshot from '../../FundingSource/BankSnapshot/BankSnapshot';
import PaperlessOptIn from './PaperlessOptIn/PaperlessOptIn';
import { PAPERLESS_TERMS_MODAL } from '../../../redux/modules/modals/modals.module';
import { getHasUserEmail } from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { currency } from '../../../utils/utils';
import {
  BUY_TRANSACTION,
  isTransactionOneOf,
  SELL_TRANSACTION,
} from '../../../utils/transactions-util';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { getEligiblePurchaseTradeDates } from '../../../redux/modules/executePurchase/executePurchase.selectors';

// SonarQube requires long strings broken by concatenation

export class Review extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSalesforceRep: props.isSalesforceRep,
      customerWebViewEnabled: props.customerWebViewEnabled,
      displayPaperlessOption: isTransactionOneOf(
        BUY_TRANSACTION,
        SELL_TRANSACTION
      )
        ? null
        : false,
      paperlessTermsShown: false,
    };
    this.updatePaperlessChecked = this.updatePaperlessChecked.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { paperless } = this.props.paperlessSetting;
    const { displayPaperlessOption } = this.state;

    if (displayPaperlessOption !== null || isEmpty(paperless)) {
      return;
    }
    const subscribed = this.isPaperlessSubscribed(paperless, 'MUTUAL_FUND');
    this.paperlessUpdate(subscribed);
  }

  updatePaperlessChecked(paperlessChecked) {
    const {
      actions: { openModal, updatePaperlessSetting },
    } = this.props;
    const { paperlessTermsShown } = this.state;

    updatePaperlessSetting(paperlessChecked);
    if (!paperlessTermsShown) {
      this.setState({
        paperlessTermsShown: true,
      });
      openModal(PAPERLESS_TERMS_MODAL);
    }
  }

  isPaperlessSubscribed(paperless, productType) {
    return paperless[0].subscriptions.some(
      (sub) => sub.productType === productType && sub.subscribedAll
    );
  }
  paperlessUpdate = (subscribed) => {
    this.setState({
      displayPaperlessOption: !subscribed,
    });
  };

  render() {
    const { isSalesforceRep, customerWebViewEnabled, displayPaperlessOption } =
      this.state;
    const {
      actions: { openModal },
      flattenedPurchasingFunds,
      hasUserEmail,
      paperlessSetting: { updatedPaperless },
      selectedBank,
      shoppingCartTotal,
      eligibleTradeDates,
      displayTradeDate,
    } = this.props;

    return (
      <div className="review-container">
        <div className="row">
          <div className="col-xs-12">
            <div className="review-bank-snapshot">
              <div className="review-bank">CHOSEN BANK</div>
              <div className="review-bank-snapshot-container">
                <BankSnapshot isReview review bank={selectedBank} />
              </div>
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span></span>
              ) : (
                <div className="review-for-an-electronic-tr">
                  <p>
                    For an electronic funds transfer (EFT) from your bank
                    account, allow 2-3 business days from the trade date.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="review-funds-container row">
          {flattenedPurchasingFunds.map((fund, index) => (
            <ReviewFund
              key={index}
              fund={fund}
              eligibleTradeDates={eligibleTradeDates}
              displayTradeDate={displayTradeDate}
            />
          ))}
        </div>
        <div className="review-summary">
          <div className="row">
            <div className="col-xs-12 col-sm-6" />
            <div className="col-xs-12 col-sm-6">
              <div className="review-total-amount">
                <span className="review-total-amount-label">Total: </span>
                {currency(shoppingCartTotal)}
              </div>
            </div>
          </div>
        </div>
        {hasUserEmail &&
          displayPaperlessOption &&
          !(!customerWebViewEnabled && isSalesforceRep) && (
            <PaperlessOptIn
              openModal={openModal}
              paperlessChecked={updatedPaperless}
              updatePaperlessChecked={this.updatePaperlessChecked}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    hasUserEmail: getHasUserEmail(state),
    eligibleTradeDates: getEligiblePurchaseTradeDates(state),
  };
};

export default compose(connect(mapStateToProps))(Review);
